module.exports = __webpack_public_path__ + "img/hk.75d0f40f.svg";